import { QueryStatus as QueryStatusType } from '@tanstack/react-query';

export type QueryStatus = QueryStatusType;
export const QueryStatus = {
  idle: 'idle' as QueryStatus,
  loading: 'loading' as QueryStatus,
  error: 'error' as QueryStatus,
  success: 'success' as QueryStatus,
};
